import * as Sentry from '@sentry/react';

const environment = import.meta.env.VITE_ENVIRONMENT;
const isProduction = environment === 'production';
const isStagingOrProduction = environment === 'staging' || isProduction;
const isLocal = typeof window !== 'undefined' && window.location.hostname === 'localhost';

const dsn = import.meta.env.VITE_SENTRY_DSN;

if (dsn) {
  Sentry.init({
    dsn,
    environment: isLocal ? 'local' : environment,
    release: import.meta.env.VITE_APP_VERSION,
    sendDefaultPii: true,

    integrations: [
      ...(isStagingOrProduction ? [Sentry.browserTracingIntegration()] : []),
      ...(isProduction
        ? [
          Sentry.replayIntegration({
            maskAllText: false,
            blockAllMedia: false,
            maskAllInputs: false
          }),
        ]
        : []),
    ],

    tracesSampleRate: isProduction ? 0.2 : 1.0,
    tracePropagationTargets: ['localhost', /^https:\/\/.*\.grassrootstexts\.com/],

    replaysSessionSampleRate: 1.0,
    replaysOnErrorSampleRate: 1.0,
  });
}
